import { render } from "./QuestionnairePage.vue?vue&type=template&id=b98f5d58&scoped=true"
import script from "./QuestionnairePage.vue?vue&type=script&lang=js"
export * from "./QuestionnairePage.vue?vue&type=script&lang=js"

import "./QuestionnairePage.vue?vue&type=style&index=0&id=b98f5d58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b98f5d58"]])

export default __exports__